import { postIam } from '../../apis';
import { IS_MOBILE } from '../../constants';
import { getLocationPath } from '../../helpers';
import { parseRequestUrl, routes } from '../../router';
import { setAlertModal, showAlertModal } from '../components/alert';

const KmcertCallback = {
  render: async () => {
    return ``;
  },
  afterRender: async () => {
    const { query } = parseRequestUrl();
    const userKey = query.get('userKey');
    const recCert = query.get('rec_cert');
    const certNum = query.get('certNum');

    // 약관동의(회원등록) API 연동
    const sendData = {
      userKey,
      recCert,
      certNum,
      email: sessionStorage.getItem('CONPAY_USER_EMAIL'),
    };

    setAlertModal();

    const finalFunc = () => {
      const locationPath = getLocationPath();

      // 결제수단 관리 화면 이동 - 결제수단 없는 상태이니 결제수단 추가 유도 (Bottom Sheet)
      if (IS_MOBILE) {
        window.parent.location.replace(
          locationPath + routes.payMethod.hashPath
        );
      } else {
        window.opener.location.replace(
          locationPath + routes.payMethod.hashPath
        );
        self.close();
      }
    };

    try {
      // 약관동의(회원가입)
      await postIam(`terms/agree`, sendData);
      finalFunc();
    } catch (e) {
      showAlertModal('오류', e.resultMessage, finalFunc);
      console.error(e);
    }
  },
};
export default KmcertCallback;
